export const questionnaire3Questions = [
  {
    id: 'fitPropercriteria_1',
    question: 'Are you licensed, registered or approved under any law in any jurisdiction (apart from being previously/currently RNF’d in Singapore) which requires licensing, registration or approval in relation to any regulated activity?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_2',
    question: 'Have you been refused the right or restricted in your right to carry on any trade, business or profession for which a specific licence, registration or other authorization is required by law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_3',
    question: 'Have you been issued a prohibition order under any Act administered by Monetary Authority of Singapore or have you been prohibited from operating in any jurisdiction by any financial services regulatory authority?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_4',
    question: 'Have you been a shareholder of any corporation which holds membership of any class or description of any operator of a market or clearing facility in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_5',
    question: 'If Yes, have you been censured, disciplined, suspended or refused membership or registration by Monetary Authority of Singapore, any other regulatory authority, an operator of a market or clearing facility, any professional body or government agency, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_6',
    question: 'Have you been the subject of any complaint made reasonably and in good faith, relating to activities that are regulated by Monetary Authority of Singapore or under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_9',
    question: 'Have you been the subject of any proceedings of a disciplinary or criminal nature or have you been notified of any potential proceedings or of any investigation which might lead to those proceedings, under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_10',
    question: 'Have you been convicted of any offence, served any term of imprisonment or are you being subject to any pending proceedings which may lead to such a conviction, under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_11',
    question: 'Have you had any judgment (in particular, that associated with a finding of fraud, misrepresentation or dishonesty) entered against you in any civil proceedings or are you a party to any pending proceedings which may lead to such a judgment, under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_12',
    question: 'Have you accepted civil liability for fraud, misrepresentation or dishonesty under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_13',
    question: 'Have you had any civil penalty enforcement action taken against you by Monetary Authority of Singapore or any other regulatory authority under any law in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_14',
    question: 'Have you contravened or abetted another person in breach of any laws or regulations, business rules or codes of conduct, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_15',
    question: 'Have you been the subject of any investigations or disciplinary proceedings or been issued a warning or reprimand by Monetary Authority of Singapore, any other regulatory authority, an operator of a market, trade repository or clearing facility, any professional body or government agency, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_16',
    question: 'Have you been refused a fidelity or surety bond, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_17',
    question: 'Have you demonstrated an unwillingness to comply with any regulatory requirement or to uphold any professional and ethical standards, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_18',
    question: 'Have you been untruthful or provided false or misleading information to Monetary Authority of Singapore or been uncooperative in any dealings with Monetary Authority of Singapore or any other regulatory authority in any jurisdiction?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_19',
    question: 'Are you or have you been a director, partner, substantial shareholder or concerned in the management of a business that has been censured, disciplined, prosecuted or convicted of a criminal offence, or been the subject of any disciplinary or criminal investigation or proceeding, in Singapore or elsewhere, in relation to any matter that took place while you were a director, partner, substantial shareholder or concerned in the management of the business?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_20',
    question: 'Are you or have you been a director, partner, substantial shareholder or concerned in the management of a business that has been suspended or refused membership or registration by Monetary Authority of Singapore, any other regulatory authority, an operator of a market, trade repository or clearing facility, any professional body or government agency, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_21',
    question: 'Have you been a director, partner, substantial shareholder or concerned in the management of a business that has gone into insolvency, liquidation or administration during the period when, or within a period of one year after, you were a director, partner, substantial shareholder or concerned in the management of the business, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_22',
    question: 'Have you been dismissed or asked to resign from office, employment, a position of trust or a fiduciary appointment or similar position, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_24',
    question: 'Have you been disqualified from acting as a director or disqualified from acting in any managerial capacity, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_25',
    question: 'Have you been an officer found liable for an offence committed by a body corporate as a result of the offence having proved to have been committed with the consent or connivance of, or neglect attributable to you, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_26',
    question: 'Are you carrying on business in, or are you acting as a representative in respect of, providing credit rating services, are you or have you been in observance of the Code of Conduct for Credit Rating Agencies?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_27',
    question: 'Are you or have you been unable to fulfil any of your financial obligations, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_28',
    question: 'Have you been placed under the Debt Repayment Scheme (DRS), entered into a compromise or scheme of arrangement with your creditors or made an assignment for the benefit of your creditors, being a compromise, scheme of arrangement or assignment that is still in operation, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_29',
    question: 'Are you subject to a judgment debt which is unsatisfied, either in whole or in part, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_30',
    question: 'Are you or have you been the subject of a bankruptcy petition, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_31',
    question: 'Have you been adjudicated a bankrupt and the bankruptcy is undischarged, whether in Singapore or elsewhere?',
    hasAttachment: true,
  },
  {
    id: 'fitPropercriteria_32',
    question: 'Are you or have you been subject to any process outside Singapore that is similar to those referred to in Questions 27 and 28 of the Fit and Proper Criteria section?',
    hasAttachment: true,
  },
 {
    id: 'fitPropercriteria_33',
    question: 'Have you been engaged in any activity, practice or conduct which would constitue tax evasion or tax evasion facilitation offence*?',
    inputLabel: 'If Yes, please specify:',
    hasAttachment: true,
    description: `*Tax evasion offence refers to any form of fraudulent conduct which seeks to divert money from the public revenue, depriving it of money to which it is entitled. Tax evasion is characterized by dishonesty on the part of the taxpayer. That may be committed either by:
- a positive act – such as submitting false or misleading information or the deliberate concealment of assets or income, or
- by omission – such as failing to declare income on which tax is due, or failing to declare the sale of asset which would be subject to capital gains tax

Tax evasion facilitation offence is committed where you knowingly and dishonestly encourage or assist the commission of a tax evasion offence. That may be committed either by:
- a positive action,
- failure to act when required to do so, or
- by wilful blindness`
  }
];